import {Pipe, PipeTransform} from '@angular/core';
import {IGridColumn} from 'src/app/custom-grid/models/grid-column.interface';
import {TCSSClasses} from 'src/app/editor-interface/models/column-styles.interface';

@Pipe({
  name: 'gridColumnClass',
  pure: true
})
export class GridColumnClassPipe<T> implements PipeTransform {
  transform(column: IGridColumn<T>, item: T): TCSSClasses | null {
    return column?.customClass?.(item) ?? null;
  }
}
